import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import s from "./SpareItem.module.scss";
import {
  ArrowUpOutlined,
  EyeOutlined,
  HeartOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import {
  getCarDetails,
  getMyCars,
  getSpareDetails,
} from "../../redux/carSlice";

const SpareItem = ({ spare }) => {
  const [isHovered, setIsHovered] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    dispatch(getMyCars());
  }, [dispatch]);

  const updateCar = async () => {
    const res = await dispatch(getCarDetails(spare?.id));

    console.log("res", res);
    if (res) {
      navigate(`/updateCar/${spare?.id}`);
    }
  };

  return (
    <div
      className={s.carCatalogueItem}
      onClick={() => dispatch(getSpareDetails(spare?.id))}
    >
      <div>
        <div
          className={s.carItem}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className={s.img_wrapper}>
            {<img src={spare?.images[0]?.image} className={s.car_img} />}
          </div>

          {isHovered ? (
            <div className={s.hovered}>
              <div className='carousel'>
                <div
                  className='slides'
                  style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                >
                  {spare?.images?.map((image, index) => (
                    <div key={index} className='slide'>
                      <img src={image.image} alt={`Slide ${index + 1}`} />
                    </div>
                  ))}
                </div>
                <div className={s.dots}>
                  {spare?.images?.map((_, index) => (
                    <span
                      key={index}
                      className={index === activeIndex ? "dot active" : "dot"}
                      onMouseEnter={() => handleDotClick(index)}
                    ></span>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className={s.car_info}>
          <Link
            to={`/spare/${spare?.id}`}
            className={s.car_info_content}
            onClick={() => dispatch(getSpareDetails(spare?.id))}
          >
            <div className={s.car_name}>
              <div className={s.brand}>
                {spare?.name} {spare?.number}
              </div>{" "}
              &nbsp;
              {/* <div className={s.model}>{car?.model?.name}</div> */}
            </div>
            <div className={s.car_price}>
              <div className={s.price_usd}>{spare?.price} USD</div>
              <div className={s.price_kgs}>{spare?.price * 90} KGS</div>
            </div>
            <div className={s.car_icons}>
              <div className={s.views}>
                <EyeOutlined className={s.icon} /> &nbsp;100
              </div>
              &nbsp;
              <div className={s.likes}>
                <HeartOutlined className={s.icon} />
                &nbsp;20
              </div>
              &nbsp;
              <div className={s.likes}>
                <MessageOutlined className={s.icon} />
                &nbsp;1
              </div>
            </div>
            <div className={s.car_text}>
              <Tag color='orange' className={s.tag}>
                {spare?.condition === "new" ? "Новая" : "БУ"}
              </Tag>
              <Tag color='orange' className={s.tag}>
                В наличии
              </Tag>
              <Tag color='orange' className={s.tag}>
                {spare?.brand?.name} {spare?.model?.name}
              </Tag>
            </div>
            <div className={s.bottom_btns}>
              <div className={s.location}>{"г.Бишкек"}</div>
              <div className={s.updated}>
                <ArrowUpOutlined /> 17 часов назад
              </div>
            </div>
          </Link>
          {/* <div className={s.panel}>
            <Link
              to={`/updateCar/${spare?.id}`}
              className={s.panel_item}
              // onClick={() => dispatch(getCarDetails(car?.id))}
            >
              <Tooltip
                title={
                  <div>
                    <FormOutlined />
                    &nbsp;Редактировать
                  </div>
                }
                color={"gray"}
                placement='topRight'
              >
                <FormOutlined className={s.icon} />
              </Tooltip>
            </Link>
            <div className={s.panel_item}>
              <Tooltip
                title={
                  <div>
                    <UpCircleOutlined />
                    &nbsp;Поднять вверх
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <UpCircleOutlined className={s.icon} />
              </Tooltip>
            </div>
            <div className={s.panel_item}>
              <Tooltip
                title={
                  <div>
                    <EyeInvisibleOutlined />
                    &nbsp;Деактивировать
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <EyeInvisibleOutlined className={s.icon} />
              </Tooltip>
            </div>
            <div className={s.panel_item}>
              <Tooltip
                title={
                  <div>
                    <ThunderboltOutlined />
                    &nbsp;Срочно
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <ThunderboltOutlined className={s.icon} />
              </Tooltip>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SpareItem;
